import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MobileNavService } from '../../shared/services/mobile-nav.service';
import { NgForm, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Organization } from './mockOrganization';
import { OrganizationService } from '../../shared/services/organization.service';
import { AssociateService } from '../../associate/shared/services/associate.service';
import { StaticValueService } from '../../shared/services/static-value.service';
import { AuthService } from '../../shared/services//auth/auth.service';
import { MatSnackBar, MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NotificationService } from '../../shared/services/notification.service';
import { ToastService } from '../../shared/services/toast.service';
import { Location } from '@angular/common';
import { Ng2ImgToolsService } from 'ng2-img-tools';

declare let Croppie;
declare let document;
import * as moment from 'moment';

@Component({
    selector: 'app-update',
    templateUrl: './update.component.html',
    styleUrls: ['./update.component.css'],
    providers: [OrganizationService]
})
export class UpdateComponent implements OnInit {

    @ViewChild('myForm')
    public myForm: NgForm;

    // validation for sales percentages
    public customerSales: Boolean = true;
    public productSales: Boolean = true;


    // businessModel checkboxes
    public businessModelDistributionCheckBox: Boolean = false;
    public businessModelProjectBasedCheckBox: Boolean = false;
    public businessModelKeyAccountsCheckBox: Boolean = false;

    public parentCompanyValidation: Boolean = true;
    public companyLeaderValidation: Boolean = true;
    public financeLeaderValidation: Boolean = true;
    public digitalLeaderValidation: Boolean = true;
    public hrLeaderValidation: Boolean = true;
    // variables for typeAhead drop downs
    public autoCompleteAssociateHrLeader: any;
    public autoCompleteAssociateCompanyleader: any;
    public autoCompleteAssociateDigitalLeader: any;
    public autoCompleteAssociateFinanceLeader: any;
    public autoCompleteAssociateLegalLeader: any;
    public autoCompleteAssociateItLeader: any;
    public autoCompleteAssociateMarketingLeader: any;
    public autoCompleteAssociatesupplyChainLeader: any;
    public autoCompleteAssociatecategoryManager: any;
    public autoCompleteAssociateComplianceOfficer : any;

    // ----------------------------------------------
    public staticDDlist: any;
    public autoCompleteAssociate: any;
    public tempBase64Img: String = null;
    public autoCompleteOrganization: any;
    public keyCounterAssc = 0;
    public keyCounterOrg = 0;
    public companyLead: any;
    public hrLeader = '';
    public financeLeader = '';
    public digitalLeader = '';
    public currencyToSymbolMap: any;
    public currencies: any;
    public errors: any;
    organization: any;
    public allOrganizations: any;
    public selectedParentCompany: any;

    constructor(public mobileNav: MobileNavService,
        public organizationService: OrganizationService,
        public router: Router,
        public associateService: AssociateService,
        public snackBar: MatSnackBar,
        public ng2ImgToolsService: Ng2ImgToolsService,
        public _location: Location,
        public staticDataService: StaticValueService,
        public authService: AuthService,
        public dialog: MatDialog,
        public notificationService: NotificationService,
        public toastService: ToastService) {
        this.staticDDlist = this.staticDataService.staticData.staticDD
        this.organization = Object.assign({}, new Organization().organization);
        this.errors = this.staticDataService.errors;
        this.staticDataService.getStaticValues().then(staticData => {
            this.currencies = Object.keys(staticData.staticDD.currencies);
            this.currencyToSymbolMap = staticData.staticDD.currencies;
        });
        this.organization.companySize.currency = '$';
    }

    ngOnInit() {
        this.organizationService.getOrganization().subscribe((data) => {
            this.allOrganizations = data;
        }, (error) => { });
        // this.errors = this.staticDataService.errors;
        // this.staticDataService.getStaticValues().then(staticData => {
        //     this.currencies = Object.keys(staticData.staticDD.currencies);
        //     this.currencyToSymbolMap = staticData.staticDD.currencies;
        // });
        // this.organization.companySize.currency = '$';
    }

    onClickMe() {
        this.mobileNav.showSideNav();
    }

    validateParentCompany() {
        let parentObj: any = this.autoCompleteOrganization.filter((org) => {
            return org.company.companyName === this.organization.company.parentCompany.name;
        });
        if (parentObj.length === 0) {
            this.parentCompanyValidation = false;
        } else {
            this.parentCompanyValidation = true;
        }
    }
    // validateAssociateAutocomplete(field: string, fieldValidate: string) {
    //   // let asscObj: any = this.autoCompleteAssociate.filter((assc) => {
    //   //   return assc.personalInformation.givenName === this.organization.companyLeaderShip[field].name
    //   // });
    //   // if ( asscObj.length === 0) {
    //   //   this[fieldValidate] = false;
    //   // } else {
    //   //   this[fieldValidate] = true;
    //   // }
    // }
    save() {
        let tempLastEdited = {
            'time': new Date(),
            // tslint:disable-next-line:max-line-length
            'name': this.authService.user.isProxyUser ? this.authService.user.name + ` (${this.authService.user.proxyUser.fullName})` : this.authService.user.name,
            'id': this.authService.user.associateId
        };
        this.businessModelArray();
        this.organization.company.lastEditedBy = Object.assign({}, tempLastEdited);
        this.organization.companyLeaderShip.lastEditedBy = Object.assign({}, tempLastEdited);
        this.organization.companyOverview.lastEditedBy = Object.assign({}, tempLastEdited);
        this.organization.companySize.lastEditedBy = Object.assign({}, tempLastEdited);
        this.organization.companySize.joinDate = moment(new Date(this.organization.companySize.joinDate))
            .format('YYYY-MM-DD');
        this.organization.lastEdited.push(tempLastEdited);
        this.organizationService.createOrganization(this.organization).subscribe((result) => {
            this.router.navigate(['/home/organization/organization-list']);
            // send notificatio to all leaders that are available
            this.notificationService.sendNotification(this.organization.companyLeaderShip.companyLeader.id,
                `Company <b>${this.organization.company.companyName}</b> has been created.`, 'Organization',
                `/home/organization/profile/view/${result['_id']}`);
            this.notificationService.sendNotification(this.organization.companyLeaderShip.hrLeader.id,
                `Company <b>${this.organization.company.companyName}</b> has been created.`, 'Organization',
                `/home/organization/profile/view/${result['_id']}`);
            if (this.organization.companyLeaderShip.financeLeader.id !== '') {
                this.notificationService.sendNotification(this.organization.companyLeaderShip.financeLeader.id,
                    `Company <b>${this.organization.company.companyName}</b> has been created.`, 'Organization',
                    `/home/organization/profile/view/${result['_id']}`);
            }
            if (this.organization.companyLeaderShip.digitalLeader.id !== '') {
                this.notificationService.sendNotification(this.organization.companyLeaderShip.digitalLeader.id,
                    `Company <b>${this.organization.company.companyName}</b> has been created.`, 'Organization',
                    `/home/organization/profile/view/view/${result['_id']}`);
            }
            // ---------------------------------------------------------
            this.toastService.success();
        }, (error) => {
            this.toastService.error(this.errors.Server['501']);
        });
    }
    organizationTyped(fieldName: string) {
        this.keyCounterOrg++;
        if (this.keyCounterOrg >= 3) {
            this.organizationService.getAllOrganizationsFilter(this.organization.company.parentCompany.name).subscribe((data) => {
                this.autoCompleteOrganization = data;
            }, (error) => {
            });
            this.keyCounterOrg = 0;
        }
    }

    // getting initial values of typeAhead dropDowns
    initialAssociates(field?: string) {
        if (this.organization.companyLeaderShip[field].name === '') {
            if (field === 'hrLeader') {
                this.associateService.getAllAssociatesFilter('a', 'initial', 'HR Manager').subscribe((data) => {
                    this.autoCompleteAssociateHrLeader = data;
                }, (error) => {
                });
            } else if (field === 'companyLeader') {
                this.associateService.getAllAssociatesFilter('a', 'initial', 'OpCo Manager').subscribe((data) => {
                    this.autoCompleteAssociateCompanyleader = data;
                }, (error) => {
                });
            } else if (field === 'financeLeader') {
                this.associateService.getAllAssociatesFilter('a', 'initial', '').subscribe((data) => {
                    this.autoCompleteAssociateFinanceLeader = data;
                }, (error) => {
                });
            } else if (field === 'digitalLeader') {
                this.associateService.getAllAssociatesFilter('a', 'initial', '').subscribe((data) => {
                    this.autoCompleteAssociateDigitalLeader = data;
                }, (error) => {
                });
            } else if (field === 'legalLeader') {
                this.associateService.getAllAssociatesFilter('a', 'initial', '').subscribe((data) => {
                    this.autoCompleteAssociateLegalLeader = data;
                }, (error) => {
                });
            } else if (field === 'itLeader') {
                this.associateService.getAllAssociatesFilter('a', 'initial', '').subscribe((data) => {
                    this.autoCompleteAssociateItLeader = data;
                }, (error) => { });
            } else if (field === 'marketingLeader') {
                this.associateService.getAllAssociatesFilter('a', 'initial', '').subscribe((data) => {
                    this.autoCompleteAssociateMarketingLeader = data;
                }, (error) => {
                });

            } else if (field === 'supplyChainLeader') {
                this.associateService.getAllAssociatesFilter('a', 'initial', '').subscribe((data) => {
                    this.autoCompleteAssociatesupplyChainLeader = data;
                }, (error) => {
                });
            } else if (field === 'categoryManager') {
                this.associateService.getAllAssociatesFilter('a', 'initial', '').subscribe((data) => {
                    this.autoCompleteAssociatecategoryManager = data;
                }, (error) => {
                });
            } else if (field === 'complianceOfficer') {
                this.associateService.getAllAssociatesFilter('a', 'initial', '').subscribe((data) => {
                    this.autoCompleteAssociateComplianceOfficer = data;
                }, (error) => {
                });
            }
        }
    }

    initialOrganizations(event) {
        this.organizationService.getAllOrganizationsFilter(event ? event : 'a').subscribe((data) => {
            this.autoCompleteOrganization = data;
        }, (error) => {
        });
    }

    managerTyped(fieldName: string) {
        this.keyCounterAssc++;
        this.organization.companyLeaderShip[fieldName].id = '';
        this.organization.companyLeaderShip[fieldName].groupId = '';
        if (fieldName === 'hrLeader') {
            if (this.keyCounterAssc >= 3) {
                this.associateService.getAllAssociatesFilter(this.organization.companyLeaderShip[fieldName].name,
                    '', 'HR Manager').subscribe((data) => {
                        this.autoCompleteAssociateHrLeader = data;
                    }, (error) => {
                    });
                this.keyCounterAssc = 0;
            }
        } else if (fieldName === 'companyLeader') {
            if (this.keyCounterAssc >= 3) {
                this.associateService.getAllAssociatesFilter(this.organization.companyLeaderShip[fieldName].name, '',
                    'OpCo Manager').subscribe((data) => {
                        this.autoCompleteAssociateCompanyleader = data;
                    }, (error) => {
                    });
                this.keyCounterAssc = 0;
            }
        } else if (fieldName === 'financeLeader') {
            if (this.keyCounterAssc >= 3) {
                this.associateService.getAllAssociatesFilter(this.organization.companyLeaderShip[fieldName].name, '', '').subscribe((data) => {
                    this.autoCompleteAssociateFinanceLeader = data;
                }, (error) => {
                });
                this.keyCounterAssc = 0;
            }
        } else if (fieldName === 'digitalLeader') {
            if (this.keyCounterAssc >= 3) {
                this.associateService.getAllAssociatesFilter(this.organization.companyLeaderShip[fieldName].name, '', '').subscribe((data) => {
                    this.autoCompleteAssociateDigitalLeader = data;
                }, (error) => {
                });
                this.keyCounterAssc = 0;
            }
        } else if (fieldName === 'legalLeader') {
            if (this.keyCounterAssc >= 3) {
                this.associateService.getAllAssociatesFilter(this.organization.companyLeaderShip[fieldName].name, '', '').subscribe((data) => {
                    this.autoCompleteAssociateLegalLeader = data;
                }, (error) => {
                });
                this.keyCounterAssc = 0;
            }
        } else if (fieldName === 'itLeader') {
            if (this.keyCounterAssc >= 3) {
                this.associateService.getAllAssociatesFilter(this.organization.companyLeaderShip[fieldName].name, '', '').subscribe((data) => {
                    this.autoCompleteAssociateItLeader = data;
                }, (error) => {
                });
                this.keyCounterAssc = 0;
            }
        } else if (fieldName === 'marketingLeader') {
            if (this.keyCounterAssc >= 3) {
                this.associateService.getAllAssociatesFilter(this.organization.companyLeaderShip[fieldName].name, '', '').subscribe((data) => {
                    this.autoCompleteAssociateMarketingLeader = data;
                }, (error) => {
                });
                this.keyCounterAssc = 0;
            }

        } else if (fieldName === 'supplyChainLeader') {
            if (this.keyCounterAssc >= 3) {
                this.associateService.getAllAssociatesFilter(this.organization.companyLeaderShip[fieldName].name, '', '').subscribe((data) => {
                    this.autoCompleteAssociatesupplyChainLeader = data;
                }, (error) => {
                });
                this.keyCounterAssc = 0;
            }
        } else if (fieldName === 'categoryManager') {
            if (this.keyCounterAssc >= 3) {
                this.associateService.getAllAssociatesFilter(this.organization.companyLeaderShip[fieldName].name, '', '').subscribe((data) => {
                    this.autoCompleteAssociatecategoryManager = data;
                }, (error) => {
                });
            }
        } else if (fieldName === 'complianceOfficer') {
            if (this.keyCounterAssc >= 3) {
                this.associateService.getAllAssociatesFilter(this.organization.companyLeaderShip[fieldName].name, '', '').subscribe((data) => {
                    this.autoCompleteAssociateComplianceOfficer = data;
                }, (error) => {
                });
            }
        }
    }
    // managerTyped(fieldName: string) {
    //   this.keyCounterAssc++;
    //   this.organization.companyLeaderShip[fieldName].id = '';
    //   this.organization.companyLeaderShip[fieldName].groupId = '';
    //   if (this.keyCounterAssc >= 3) {
    //       this.associateService.getAllAssociatesFilter(this.organization.companyLeaderShip[fieldName].name, '' , '').
    //       debounceTime(500)
    //       .subscribe((data) => {
    //           this.autoCompleteAssociate = data;
    //       }, ( error) => {
    //       });
    //       this.keyCounterAssc = 0;
    //       }
    // }

    clickDropDownOrganization(field: string) {
        console.log('ORganization', this.selectedParentCompany.company);
        this.organization.company[field].name = this.selectedParentCompany.company.companyName;
        this.organization.company[field].id = this.selectedParentCompany._id;
        this.organization.company[field].companyId = this.selectedParentCompany.company.companyId;
        console.log('ORganization----1', this.organization.company);
        // this.validateParentCompany();
    }


    clickDropDown(recievedAssociate: any, field: string) {
        this.organization.companyLeaderShip[field].name = recievedAssociate.personalInformation.fullName;
        this.organization.companyLeaderShip[field].id = recievedAssociate._id;
        this.organization.companyLeaderShip[field].groupId = recievedAssociate.groupId;
  }

  onFileChange(event) {
    const reader = new FileReader();
    const reader2 = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      if ( event.target.files[0].type === 'image/png' || event.target.files[0].type === 'image/jpg'
      || event.target.files[0].type === 'image/jpeg') {
        reader.readAsDataURL(file);
        reader.onload = (onLoadResult) => {
            this.tempBase64Img = reader.result;
            this.organization.avatar = {
                filename: file.name,
                filetype: file.type,
                imageData: reader.result.split(',')[1]
            };
            const imageElem = new Image();
            imageElem.onload = (imageOnloadResult) => {
                // if (imageOnloadResult['path'][0]['width'] < 500 && imageOnloadResult['path'][0]['height'] < 150) {
                //     this.openCropImageDialog(reader.result);
                // } else {
                    const curWidth = imageOnloadResult['path'][0]['width'];
                    const curHeight = imageOnloadResult['path'][0]['height'];
                    let newWidth = curWidth;
                    let newHeight = curHeight;
                    const requiredRatio = 500 / 150;
                    const currentRatio = curWidth / curHeight;
                    if (currentRatio > requiredRatio) {
                        newHeight = curWidth / requiredRatio;
                    } else {
                        newWidth = curHeight * requiredRatio;
                    }
                    // tslint:disable-next-line:max-line-length
                    this.ng2ImgToolsService.resizeExactFillImage(event.target.files[0], newWidth, newHeight, '#ffffff').subscribe(result => {
                        reader2.readAsDataURL(result);
                        reader2.onload = () => {
                            this.openCropImageDialog(reader2.result);
                        }
                    }, err => {
                        console.log(err);
                    });
                // }
              };
            imageElem.src = onLoadResult['target']['result'];
          };
        } else {
          this.toastService.error(this.errors.File["404"]);
          }
        }
    }

    // image crop functionality
    openCropImageDialog(imageDataEvent): void {
        const dialogRef = this.dialog.open(ImageCropDialogComponent, {
            width: '500px',
            // height: '300px',
            data: { event: imageDataEvent }
        });

        dialogRef.afterClosed().subscribe(result => {
            this.organization.avatar.imageData = result;
            this.tempBase64Img = result;
        });
    }
    backBtnClick() {
        this._location.back();
    }

    businessModelArray() {
        let tempArray = [];
        if (this.businessModelDistributionCheckBox) {
            tempArray.push('Distribution');
        } if (this.businessModelProjectBasedCheckBox) {
            tempArray.push('Project Based');
        } if (this.businessModelKeyAccountsCheckBox) {
            tempArray.push('Key Accounts');
        }
        this.organization.companyOverview.businessModel = Object.assign([], tempArray);
    }

    validateCustomerSales() {
        let installers = this.organization.companySize.customerSales.installers;
        let industry = this.organization.companySize.customerSales.industry;
        let infrastructure = this.organization.companySize.customerSales.infrastructure;
        let others = this.organization.companySize.customerSales.others;
        let tempCustomerSalesSum = installers + industry + infrastructure + others;
        if (tempCustomerSalesSum !== 100) {
            this.customerSales = false;
        } else {
            this.customerSales = true;
        }
    }

    validateProductSales() {
        let cablesAndWires = this.organization.companySize.productSales.cablesAndWires;
        let buildingAutomationAndConstruction = this.organization.companySize.productSales.buildingAutomationAndConstruction;
        let infrastructure = this.organization.companySize.productSales.infrastructure;
        let lighting = this.organization.companySize.productSales.lighting;
        let industrialAutomation = this.organization.companySize.productSales.industrialAutomation;
        let hvacAndRenewableEnergy = this.organization.companySize.productSales.hvacAndRenewableEnergy;
        let safetyToolsAndEngineeringSupplies = this.organization.companySize.productSales.safetyToolsAndEngineeringSupplies;
        let specialities = this.organization.companySize.productSales.specialities;
        let others = this.organization.companySize.productSales.others;
        let tempProductSalesSum = cablesAndWires +
            industrialAutomation + infrastructure
            + buildingAutomationAndConstruction + lighting
            + hvacAndRenewableEnergy +
            safetyToolsAndEngineeringSupplies
            + specialities + others;
        if (tempProductSalesSum !== 100) {
            this.productSales = false;
        } else {
            this.productSales = true;
        }
    }

    removeAvatar(){
        this.tempBase64Img = undefined;
      }

}


// @Component({
//   selector: 'app-image-crop-dialog',
//   styleUrls: ['./update.component.css'],
//   template: `
//   <div class="col-xs-12 fl-n"><h2 class="xs-m-0 xs-pb-10" >Image Adjustment</h2></div>
//   <div class="col-xs-12 xs-pt-4 xs-pb-4 blue_bar alert alert-info fl-n" translate>Recommended image resolution is <span class="fw-bold">500x150</span></div>
//   <div style="width: 100%;height: 100%" class="pull-left xs-pb-15 xs-pt-15">
//               <image-cropper
//                   [imageChangedEvent]="imageChangedEvent"
//                   [maintainAspectRatio]="true"
//                   [aspectRatio]="500/150"
//                   format="png"
//                   (imageCropped)="imageCropped($event)"></image-cropper>
//               </div>
//               <div class="md-mt-10 xs-pr-20">

//               <button type="button" (click)="onSaveClick()" class="pull-right btn btn-primary xs-ml-5" translate>Save</button>
//                   <button type="button"  class="pull-right btn btn-primary cancel_btn" (click)="cancel()" translate>Cancel</button>

//               </div>`,
//   // styles: ['img { width: 100%;}']
// })
// export class ImageCropDialogComponent {
//   imageChangedEvent: any = '';
//   croppedImage: any = '';

//   constructor(
//       public dialogRef: MatDialogRef<UpdateComponent>,
//       @Inject(MAT_DIALOG_DATA) public data: any) {
//       this.imageChangedEvent = data.event;
//   }

//   onSaveClick(): void {
//       this.dialogRef.close(this.croppedImage);
//   }

//   // fileChangeEvent(event: any): void {
//   //     this.imageChangedEvent = event;
//   // }
//   imageCropped(image: string) {
//       this.croppedImage = image;
//   }
//   cancel() {
//     this.dialogRef.close();
// }

// }




@Component({
    selector: 'app-image-crop-dialog',
    template: `<div class="width: 100%;">
  <div class="col-xs-12 fl-n xs-pl-0"><h2 class="xs-m-0 xs-pb-10" >Image Adjustment</h2></div>
<div class="col-xs-12 xs-pt-4 xs-pb-4 blue_bar alert alert-info fl-n" translate style="    margin: 0 !important; width: 100% !important;">
Recommended image resolution is <span class="fw-bold">500x150</span></div>
<div style="width: 100%;height: 100%" class="pull-left xs-pb-15 xs-pt-15">
                  <div id="imageToCropDiv">
                      <img [ngClass]="{'hidden': imageHidden}" #imageToCrop2 id="imageToCrop" src="{{imageChangedEvent}}"/>
                  </div>
              </div>
              <div class="md-mt-10">
            <button type="button" (click)="onSaveClick()" class="pull-right btn btn-primary xs-ml-5" translate>Save</button>
            <button type="button" class="pull-right btn btn-primary cancel_btn" (click)="cancel()" translate>Cancel</button>
            </div>`,
    styleUrls: ['./update.component.css'],
})
export class ImageCropDialogComponent implements OnInit {
  @ViewChild('imageToCrop2') imageToCrop2: ElementRef;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  croppy: any;
  imageHidden = true;
  constructor(
      public dialogRef: MatDialogRef<UpdateComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any) {
      this.imageChangedEvent = data.event;
  }

  ngOnInit() {
    this.imageChangedEvent = this.data.event;
    setTimeout(() => {
          this.imageHidden = false;
          this.croppy = new Croppie(document.getElementById('imageToCrop'), {
            enableExif: true,
            viewport: {
                width: 400,
                height: 120
            },
            boundary: {
                width: 450,
                height: 372
            },
            enableOrientation: true
        });
    }, 250);
  }

  onSaveClick(): void {
      this.croppy.result().then(result => {
          this.dialogRef.close(result);
      });
  }

  fileChangeEvent(event: any): void {
      this.imageChangedEvent = event;
  }

  imageCropped(image: string) {
      this.croppedImage = image;
  }
  cancel() {
      this.dialogRef.close();
  }

}

